import PropTypes from 'prop-types'
import React, {
  lazy, Suspense,
} from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Padrao from './features/utils/views/Padrao'

const Home = lazy(() => import('./features/home'))
const Login = lazy(() => import('./features/login'))
const Erro = lazy(() => import('./features/utils/views/Erro'))

const Routes = ({ firebase }) => (
  <BrowserRouter>
    <Suspense fallback={<div />}>
      <Switch>
        <Route exact path="/" render={() => <Padrao firebase={firebase} pagina={<Home firebase={firebase} />} />} />
        <Route exact path="/login" render={() => <Login firebase={firebase} />} />
        <Route path="*" render={() => <Padrao firebase={firebase} pagina={<Erro />} />} />
      </Switch>
    </Suspense>
  </BrowserRouter>
)

Routes.propTypes = {
  firebase: PropTypes.objectOf(PropTypes.any),
}

Routes.defaultProps = {
  firebase: undefined,
}

export default Routes
